export const businessListings = [
  {
    id: 1,
    title: "Profitable E-commerce Store — Beauty Niche",
    price: "$45,000",
    category: "E-commerce",
    location: "Online",
    image: "https://public.readdy.ai/ai/img_res/1c0ea576d986a803135e7e7a12a11f16.jpg",
    description: "Established beauty e-commerce store with 3 years of history, $12K monthly revenue, loyal customer base.",
    type: "For Sale",
    revenue: "$12K/mo",
  },
  {
    id: 2,
    title: "Restaurant Franchise — Fast Food Chain",
    price: "$180,000",
    category: "Food & Beverage",
    location: "Miami, FL",
    image: "https://readdy.ai/api/search-image?query=fast%20food%20restaurant%20franchise%20interior%20modern%20clean%20professional%20bright&width=400&height=260&seq=biz2&orientation=landscape",
    description: "Turnkey fast food franchise opportunity in high-traffic Miami location. Full training and support provided.",
    type: "For Sale",
    revenue: "$35K/mo",
  },
  {
    id: 3,
    title: "Digital Marketing Agency — Seeking Partner",
    price: "$25,000",
    category: "Marketing",
    location: "Remote",
    image: "https://readdy.ai/api/search-image?query=digital%20marketing%20agency%20office%20team%20professional%20modern%20clean%20bright&width=400&height=260&seq=biz3&orientation=landscape",
    description: "Growing digital marketing agency seeking equity partner. 15 active clients, $8K MRR.",
    type: "Partnership",
    revenue: "$8K/mo",
  },
  {
    id: 4,
    title: "Auto Repair Shop — Established 12 Years",
    price: "$220,000",
    category: "Automotive",
    location: "Dallas, TX",
    image: "https://readdy.ai/api/search-image?query=auto%20repair%20shop%20garage%20professional%20clean%20modern%20tools%20equipment&width=400&height=260&seq=biz4&orientation=landscape",
    description: "Well-established auto repair shop with loyal clientele, 4 bays, all equipment included.",
    type: "For Sale",
    revenue: "$28K/mo",
  },
  {
    id: 5,
    title: "Wanted: Logistics Business to Acquire",
    price: "Budget: $500K",
    category: "Logistics",
    location: "Nationwide",
    image: "https://readdy.ai/api/search-image?query=logistics%20warehouse%20trucks%20fleet%20professional%20clean%20modern%20aerial%20view&width=400&height=260&seq=biz5&orientation=landscape",
    description: "Investor group seeking to acquire established logistics or freight company. Serious inquiries only.",
    type: "Wanted",
    revenue: "N/A",
  },
  {
    id: 6,
    title: "SaaS Platform — HR Management Tool",
    price: "$95,000",
    category: "Technology",
    location: "Online",
    image: "https://readdy.ai/api/search-image?query=SaaS%20HR%20management%20software%20dashboard%20interface%20modern%20clean%20professional&width=400&height=260&seq=biz6&orientation=landscape",
    description: "Profitable HR SaaS with 120 paying subscribers, $6K MRR, clean codebase, full documentation.",
    type: "For Sale",
    revenue: "$6K/mo",
  },
];
